module.exports = __webpack_public_path__ + "static/media/TN-Men-Wallets.76525459.svg";